import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import { isOffline } from "@/lib/offline/is-offline";
import { readAppShellSnapshot } from "@/lib/offline/app-shell-snapshot";

/**
 * Usuario actual. Resiliencia offline (warm): si la query no resolvió y estamos
 * sin conexión, devolvemos el `profile` del snapshot del app-shell (subconjunto
 * _id/name/email/image) como fallback de presencia + display, para que el
 * AuthGuard no quede en spinner infinito al navegar/remontar offline.
 */
export function useCurrentUser() {
  const user = useQuery(api.system.users.queries.getCurrentUser);

  if (user !== undefined) return user; // resuelto (doc o null)
  if (!isOffline()) return user; // undefined = cargando; online priorizamos la query

  const profile = readAppShellSnapshot()?.context?.profile;
  return profile ? (profile as unknown as NonNullable<typeof user>) : undefined;
}
